import {
  fetchSystemStatus,
  type SystemStatus,
} from '@mxa-argos/modules/system-status/services/system-status.service';
import { useEffect, useState } from 'react';

const POLL_INTERVAL_MS = 60_000;

interface UseSystemStatusResult {
  status: SystemStatus | null;
  isError: boolean;
}

export function useSystemStatus(): UseSystemStatusResult {
  const [status, setStatus] = useState<SystemStatus | null>(null);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let isActive = true;

    const load = async () => {
      try {
        const next = await fetchSystemStatus();
        if (!isActive) {
          return;
        }
        setStatus(next);
        setIsError(false);
      } catch {
        if (!isActive) {
          return;
        }
        setIsError(true);
      }
    };

    void load();
    const interval = setInterval(() => {
      void load();
    }, POLL_INTERVAL_MS);

    return () => {
      isActive = false;
      clearInterval(interval);
    };
  }, []);

  return { status, isError };
}
